import React from 'react';
import { motion } from 'framer-motion';

const CTA = () => {
  const appointmentLink = "https://nextcloud.managershop.com/index.php/apps/appointments/pub/39t5c1133b0ztr29/form";

  return (
    <section id="contact" className="py-24 bg-azure-600 w-full">
      <div className="container mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="max-w-3xl mx-auto"
        >
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-8">
            Bauen Sie auf ein stabiles Fundament.
          </h2>
          <p className="text-xl text-azure-100 mb-12">
            Lassen Sie uns gemeinsam prüfen, ob Ihre Prozesse bereit für die Beschleunigung sind.
          </p>
          <div className="flex flex-col items-center gap-4">
            <a
              href={appointmentLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-black text-white px-12 py-5 rounded-lg text-xl font-bold hover:bg-gray-900 transition-all shadow-2xl"
            >
              Kostenloses Erstgespräch buchen
            </a>
            <p className="text-azure-100 text-sm font-bold uppercase tracking-widest">
              Kostenlos. Unverbindlich.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTA;